import { render } from "./DonutSalesItem.vue?vue&type=template&id=4ca07d65"
import script from "./DonutSalesItem.vue?vue&type=script&lang=js"
export * from "./DonutSalesItem.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__